import { theme } from '@fivehealth/botero'
import { merge } from 'lodash'

export default merge(theme, {
  /* local theming */
})
